import { gql } from "@apollo/client";

export const CREATE_ORDER_LINE = gql`
  mutation CreateOrderLineMutation($input: CreateOrderLineInput!) {
    createOrderLine(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_ORDER_LINE = gql`
  mutation UpdateOrderLineMutation($id: Int!, $input: UpdateOrderLineInput!) {
    updateOrderLine(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_ORDER_LINE = gql`
  mutation RemoveOrderLineMutation($id: Int!) {
    removeOrderLine(id: $id) {
      ok
      error
    }
  }
`;

export const ORDER_LINE = gql`
  query OrderLineQuery($id: Int!) {
    orderLine(id: $id) {
      ok
      error
      result {
        id
        frozenLabel
        quantity
        unitPriceCents
        vatRate
        priceOrigin
        lineTotalCents
      }
    }
  }
`;

export const ORDER_LINES = gql`
  query OrderLinesQuery($where: OrderLinesFiltersInput!) {
    orderLines(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        frozenLabel
        quantity
        unitPriceCents
        vatRate
        lineTotalCents
      }
    }
  }
`;
